import React from "react";
import SegmentModeToggle from "../../../ui/segment-mode-toggle";
import DraggableStepper from "../../../ui/draggable-stepper";
import { resolveSegmentMode } from "../../../../utils/workoutPlanUtils";

const explain = (mode, threshold, minutes, noun) => {
  if (mode === "off") return `No ${noun}.`;
  if (mode === "on") return `Always added, at the minutes below.`;
  if (threshold === 0) return `Added and sized to fit your time.`;
  return minutes >= threshold
    ? `Added and sized to fit, because ${minutes} min is at least your ${threshold} min threshold.`
    : `Skipped today: ${minutes} min is under your ${threshold} min threshold.`;
};

const Segment = ({ id, label, mode, onMode, explanation, minutes, onMinutes, min, max }) => (
  <div className="space-y-3 rounded-xl border border-border bg-background/40 p-3">
    <div className="flex items-center justify-between gap-3">
      <label htmlFor={id} className="whitespace-nowrap text-sm font-semibold text-foreground">
        {label}
      </label>
      <SegmentModeToggle id={id} value={mode} onChange={onMode} />
    </div>
    <p className="text-xs leading-snug text-muted-foreground">{explanation}</p>
    {mode === "on" && (
      <DraggableStepper
        label={`${label} minutes`}
        value={minutes}
        onChange={onMinutes}
        min={min}
        max={max}
        step={1}
        unit="min"
      />
    )}
  </div>
);

const TimingDetail = ({ config, onModeChange, onWarmupMinutes, onCooldownMinutes }) => {
  const minutes = config.sessionDuration || 45;
  const warm = resolveSegmentMode(config, "warmup");
  const cool = resolveSegmentMode(config, "cooldown");
  return (
    <>
      <Segment
        id="warmup-mode"
        label="Warm-up"
        mode={warm}
        onMode={(m) => onModeChange("warmup", m)}
        explanation={explain(warm, config.autoWarmupThreshold ?? 30, minutes, "warm-up")}
        minutes={config.warmupDuration || 5}
        onMinutes={onWarmupMinutes}
        min={5}
        max={30}
      />
      <Segment
        id="cooldown-mode"
        label="Cool-down"
        mode={cool}
        onMode={(m) => onModeChange("cooldown", m)}
        explanation={explain(cool, config.autoCooldownThreshold ?? 30, minutes, "cool-down")}
        minutes={config.cooldownDuration || 5}
        onMinutes={onCooldownMinutes}
        min={3}
        max={10}
      />
      <p className="text-xs leading-relaxed text-muted-foreground/80">
        Defaults and thresholds are in Profile, under Training Defaults.
      </p>
    </>
  );
};

export default TimingDetail;
